import { render, staticRenderFns } from "./23-Display.vue?vue&type=template&id=a63e4558&scoped=true"
import script from "./23-Display.vue?vue&type=script&lang=ts"
export * from "./23-Display.vue?vue&type=script&lang=ts"
import style0 from "./23-Display.vue?vue&type=style&index=0&id=a63e4558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63e4558",
  null
  
)

export default component.exports